import React from 'react';
import { TextColorSmallIcon } from '../../../@/components/tiptap-icons/text-color-small-icon';
import { normalizePsTextColorToken } from '../extensions/PsTextColorExtension.js';

/**
 * Compact text-color menu (icon + label rows), shared by announcement and post editors.
 */
export function TextColorListMenu({ colors, selectedToken, onSelect }) {
  const selected = normalizePsTextColorToken(selectedToken);

  return colors.map((swatch) => {
    const swatchId = normalizePsTextColorToken(swatch.id);
    const isSelected = selected === swatchId;

    return (
      <button
        key={swatch.id}
        type="button"
        className={['ps-announcement-color-menu__option', isSelected ? 'is-selected' : '']
          .filter(Boolean)
          .join(' ')}
        aria-label={`Set text color ${swatch.label}`}
        style={{ color: swatch.hex }}
        onMouseDown={(e) => e.preventDefault()}
        onClick={() => onSelect(swatch.id)}
      >
        <TextColorSmallIcon
          className="tiptap-button-icon"
          style={{ width: 16, height: 16, color: swatch.hex }}
        />
        {swatch.label}
      </button>
    );
  });
}
